// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settingsCard,
.authentSetting {
  background: #ffffff;
  border-radius: 30px;
  padding: 20px;
  box-shadow: 0px 4px 4px rgba(6, 6, 6, 0.157);
  margin-top: 20px;
}
.settingsCard p,
.authentSetting p {
  color: #898989;
}
.settingsCard label,
.authentSetting label {
  /* margin-bottom: 10px; */
}
/* .settingsCard .body{
    padding: 0;
} */
.settingsCard h4 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
}
.authentSetting h4 {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
}

.settingsCard .body,
.authentSetting .body {
  background: none;
}
.auth {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}
.auth .label {
  display: flex;
  flex-direction: column;
  margin: 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  color: #9e9e9e;
  font-weight: 600;
  font-size: 14px;
}

.info-row .value {
  color: #000;
  font-weight: 600;
  font-size: 14px;
}

.system-details {
  margin-top: 30px;
}

.settingsCard {
  form {
    gap: 10px;
    display: unset;
  }
  .form-header{
    display: flex;
     gap: 20px;
  }

  @media (max-width: 650px) {
    .form-header {
      flex-direction: column;
      margin: 0 10px;
      gap: 5px;
    }
  }

  .text-inputs{
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  input, select{
    width: 100%;
    margin-top: 10px;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box; 
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/settings.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,cAAc;EAChB;EACA;IACE,aAAa;KACZ,SAAS;EACZ;;EAEA;IACE;MACE,sBAAsB;MACtB,cAAc;MACd,QAAQ;IACV;EACF;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":[".settingsCard,\r\n.authentSetting {\r\n  background: #ffffff;\r\n  border-radius: 30px;\r\n  padding: 20px;\r\n  box-shadow: 0px 4px 4px rgba(6, 6, 6, 0.157);\r\n  margin-top: 20px;\r\n}\r\n.settingsCard p,\r\n.authentSetting p {\r\n  color: #898989;\r\n}\r\n.settingsCard label,\r\n.authentSetting label {\r\n  /* margin-bottom: 10px; */\r\n}\r\n/* .settingsCard .body{\r\n    padding: 0;\r\n} */\r\n.settingsCard h4 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-bottom: 10px;\r\n}\r\n.authentSetting h4 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.settingsCard .body,\r\n.authentSetting .body {\r\n  background: none;\r\n}\r\n.auth {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 20px;\r\n}\r\n.auth .label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0;\r\n}\r\n\r\n.info-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 15px 0;\r\n  border-bottom: 1px solid #eee;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.info-row:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-row .label {\r\n  color: #9e9e9e;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.info-row .value {\r\n  color: #000;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n\r\n.system-details {\r\n  margin-top: 30px;\r\n}\r\n\r\n.settingsCard {\r\n  form {\r\n    gap: 10px;\r\n    display: unset;\r\n  }\r\n  .form-header{\r\n    display: flex;\r\n     gap: 20px;\r\n  }\r\n\r\n  @media (max-width: 650px) {\r\n    .form-header {\r\n      flex-direction: column;\r\n      margin: 0 10px;\r\n      gap: 5px;\r\n    }\r\n  }\r\n\r\n  .text-inputs{\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n  }\r\n  input, select{\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    padding: 12px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    box-sizing: border-box; \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
